
    const data = {"name":"src/core/icons/history","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13.5 8H12v5l4.28 2.54.72-1.21-3.5-2.08V8M13 3a9 9 0 0 0-9 9H1l3.96 4.03L9 12H6a7 7 0 0 1 7-7 7 7 0 0 1 7 7 7 7 0 0 1-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.896 8.896 0 0 0 13 21a9 9 0 0 0 9-9 9 9 0 0 0-9-9\"/>","originalColors":[],"stopColors":[]}}

            export default data
            